import TaxCalculator from '@/components/react/TaxCalculator';


export function Calculator() {
  return (
    <section id="calculadora" className="py-20 lg:py-28 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-gold-600 font-semibold text-sm uppercase tracking-wider">Simule sua Economia</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 mt-3 mb-4">
            Calculadora de Aluguel - P.F. vs Holding
          </h2>
          <p className="text-lg text-neutral-600">
            Compare a carga tributária atual com o cenário de holding e quantifique o aumento de lucratividade e conformidade.
          </p>
        </div>

        {/* Calculator Component */}
        <div className="max-w-4xl mx-auto">
          
            <TaxCalculator />
         
        </div>
      </div>
    </section>
  );
}
